import { render } from "./page-mortgagerates.vue?vue&type=template&id=4c447a58"
import script from "./page-mortgagerates.js?vue&type=script&lang=js"
export * from "./page-mortgagerates.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__